module.exports = __webpack_public_path__ + "assets/img/Type E (68).b1d1370f.jpg";